import Axios from "./index";
import { parseFilters } from "./helper";

export const fetchTimeline = (params) => {
  return Axios.get(`/user/posts/timeline`, { params: parseFilters(params) });
};

export const indexPosts = params => {
  // if(params?.filter?.attachment_type === 'singles'){
  //   const obj =  parseFilters(params)
  //   const { page_number, page_size } = obj
  //   const authorid = obj['filter[author_id]']
  //   return Axios.get(`/user/latest_release?page_number=${page_number}&page_size=${page_size}&filter[user_id]=${authorid}`);
  // }else{
  //   return Axios.get(`/user/posts`, { params: parseFilters(params) });
  // }
  return Axios.get(`/user/posts`, { params: parseFilters(params) });

};

export const createPost = postParams => {
  return Axios.post(`/user/posts`, postParams);
};

export const showPost = post_id => {
  return Axios.get(`/user/posts/${post_id}`);
};

export const deletePost = post_id => {
  return Axios.delete(`/user/posts/${post_id}`);
};

export const updatePost = postParams => {
  return Axios.put(`/user/posts/${postParams.post_id}`, postParams);
};
